import {Nullish} from 'shared/web';

export function extractParamsFromString(string: string | Nullish) {
  if (!string) {
    return [];
  }

  return string.match(/[^{}]*(?=\})/g)?.filter((match) => match !== '') || [];
}
